import { render, staticRenderFns } from "./AccessibilityPolicy.vue?vue&type=template&id=37c39fa2&"
import script from "./AccessibilityPolicy.vue?vue&type=script&lang=ts&"
export * from "./AccessibilityPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports